import React from "react";
import { Outlet } from "react-router-dom";
import PageHeading from "Layout/AppMain/PageHeading";

const Substitutions = () => {
    return (
        <>
          <PageHeading />
        <Outlet />
        </>
    )
};

export default Substitutions;
